import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';

@Component({
	selector: 'app-welcome-wizard',
	templateUrl: './welcome-wizard.component.html',
	styleUrls: ['./welcome-wizard.component.css']
})
export class WelcomeWizardComponent implements OnInit {
	@ViewChild('inputEmail') inputEmail: ElementRef;
	@ViewChild('inputName') inputName: ElementRef;

	loading = false;

	step: number = 1;			// 1-3

	formEmail: UntypedFormGroup;
	formName: UntypedFormGroup;
	formAPIKeys: UntypedFormGroup;

	emailValid: boolean;
	nameValid: boolean = false;

	constructor(
		private fb: UntypedFormBuilder,
		private clientService: ClientService,
		private contextService: ContextService,
		private router: Router
	) { }

	ngOnInit() {
		this.initFormEmail();
		this.initFormName();
	}

	initFormEmail() {
		this.formEmail = this.fb.group({
			email: new UntypedFormControl(this.contextService.procoreUserInfo.email, [Validators.required]),
		});

		this.emailValid = null;
	}

	initFormName() {
		this.formName = this.fb.group({
			name: new UntypedFormControl('', [Validators.required]),
		});

		this.nameValid = null;
	}

	doEmailValidation(e: any) {
		let emailValue = '';
		if (e.target?.value) {
			emailValue = e.target.value;
		} else {
			emailValue = e;
		}
		const regexPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (regexPattern.test(emailValue)) {
			this.emailValid = true;
		} else {
			this.emailValid = false;
		}
	}

	doNameValidation(e: any) {
		if (e.target.value) {
			this.nameValid = true;
		} else {
			this.nameValid = false;
		}
	}

	// Retrieve or create the Stripe Customer ID based on the supplied email and company name.
	computeCustomerId() {
		this.loading = true;

		// Perform a lookup in Stripe by email
		this.clientService.createClientCustomerId(this.inputEmail.nativeElement.value, this.inputName.nativeElement.value)
			.subscribe((customerId) => {
				console.log('AS - SET CUSTOMER ID: ' + customerId);
				this.contextService.stripeCustomerId = customerId;

				this.computeClient();
			});
	}

	// Retrieve or create the Client based on the Stripe Customer ID.
	computeClient() {
		// Create a client
		this.clientService.createClient(this.inputName.nativeElement.value, this.contextService.stripeCustomerId, this.contextService.procoreContextObject.context.company_id)
			.subscribe((client) => {
				console.log(client);
				console.log('AS - SET CLIENT: ' + client.clientId);

				this.contextService.client = client;
				this.contextService.clientDetailProcore = client.clientDetailProcore;

				this.router.navigate(['/welcome/configure']);
			});
	}

	selectBack() {
		this.step = this.step - 1;
	}

	selectStart() {
		this.step = 2;
		this.initFormEmail();
		this.doEmailValidation(this.contextService.procoreUserInfo.email);
	}

	selectCustomer() {
		this.step = 3;
		this.initFormName();
	}
}
